import { ReservationQuestionAnswer } from "../reservation/reservation-question-answer";

export class TicketReservationPlugin {
    public id: number;
    public reservationTime: Date;
    public categoryId: number;
    public additionalReservationData: ReservationQuestionAnswer[];
    public code: string;
    public email: string;
    public pesel: string;
    public phoneNumber: string;
    public captchaToken: string;
    public sendMailOnReservation: boolean;
    public sendSmsOnReservation: boolean;
    public supportsWcag: boolean;
    public isTimeSelected: boolean;
}